import { all } from 'redux-saga/effects';
import { sagas as contentSagas } from './content/sagas';
import { sagas as publishedEventSagas } from './published-event/sagas';
import { sagas as publisherSagas } from './publisher/sagas';
import { unfixedConcat } from '../../../utils';

function* publisherPortalSagas() {
  yield all(unfixedConcat(
    contentSagas,
    publishedEventSagas,
    publisherSagas
  ));
}

export default publisherPortalSagas;



// WEBPACK FOOTER //
// ./src/state/modules/publisher-portal/sagas.js